import { PropsWithChildren } from 'react'
import { SwitchDesignModes } from './Switch.types'
import { FancySwitch, IFancySwitchProps } from '../FancySwitch/FancySwitch'
import { Box, Typography } from '@material-ui/core'
import Brightness3OutlinedIcon from '@material-ui/icons/Brightness3Outlined'
import Brightness7Icon from '@material-ui/icons/Brightness7'
import styled, { useTheme } from 'styled-components'

interface ISwitchProps extends Pick<IFancySwitchProps, 'small' | 'onChange' | 'state'> {
  design?: SwitchDesignModes
  hired?: boolean
  disabled?: boolean
}

const StyledMoonWrapper = styled(Box)`
  && {
    transform: rotate(150deg);
  }
`

export const Switch = ({ design = SwitchDesignModes.DEFAULT, hired, disabled, ...rest }: PropsWithChildren<ISwitchProps>) => {
  const theme = useTheme()

  switch (design) {
    case SwitchDesignModes.MODE_SWITCH:
      return (
        <FancySwitch
          {...rest}
          small={false}
          currentStateLabel={isOn => {
            return (
              <>
                {isOn ? (
                  <Box color={theme.colors.accent1} display="flex" justifyContent="center" alignItems="center">
                    <StyledMoonWrapper>
                      <Brightness3OutlinedIcon htmlColor={theme.colors.accent1} />
                    </StyledMoonWrapper>{' '}
                    <Typography variant="overline" component="span">
                      <Box color={theme.colors.accent1}>Dark</Box>
                    </Typography>
                  </Box>
                ) : (
                  <Box color={theme.colors.accent1} display="flex" justifyContent="center" alignItems="center">
                    <Brightness7Icon htmlColor={theme.colors.accent1} />
                    <Typography variant="overline" component="span">
                      <Box color={theme.colors.accent1}>Light</Box>
                    </Typography>
                  </Box>
                )}
              </>
            )
          }}
          onDisabledState={() => {
            return (
              <Box display="flex" justifyContent="center" alignItems="center">
                <StyledMoonWrapper>
                  <Brightness3OutlinedIcon htmlColor={theme.colors.supplementary} />
                </StyledMoonWrapper>{' '}
                <Typography variant="caption" component="span">
                  <Box color={theme.colors.accent}>Dark</Box>
                </Typography>
              </Box>
            )
          }}
          offDisabledState={() => {
            return (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Brightness7Icon htmlColor={theme.colors.supplementary} />
                <Typography variant="caption" component="span">
                  <Box color={theme.colors.accent}>Light</Box>
                </Typography>
              </Box>
            )
          }}
        />
      )
    case SwitchDesignModes.DEFAULT:
      return <FancySwitch {...rest} />

    case SwitchDesignModes.HIRE_SWITCH:
      return (
        <FancySwitch
          {...rest}
          onActiveTextColor={theme.colors.supplementary}
          hired={hired}
          currentStateLabel={isOn => {
            return (
              <>
                <Box
                  width="100%"
                  height="100%"
                  borderRadius={8}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <Typography variant="subtitle2">{'Hired'}</Typography>
                </Box>
              </>
            )
          }}
          onDisabledState={() => {
            return (
              <Box color={theme.colors.supplementary}>
                <Typography variant="subtitle2">Hired</Typography>
              </Box>
            )
          }}
          offDisabledState={() => {
            return (
              <Box>
                <Typography variant="subtitle2"></Typography>
              </Box>
            )
          }}
        />
      )
      
    case SwitchDesignModes.RESUME_SWITCH:
      return (
        <FancySwitch
          {...rest}
          small 
          bgcolor={theme.colors.bgPrimary}
          activeBGColor={theme.colors.supplementary1}
          onInactiveTextColor={theme.colors.supplementary1}
          offInactiveTextColor={theme.colors.supplementary1}
        />
      )

      case SwitchDesignModes.NOTIFICATIONS_SWITCH:
      return (
        <FancySwitch
          {...rest}
          small={false}
          width="12.375rem"
          height="2.813rem"
          disabled={disabled}
          currentStateLabel={isOn => {
            return (
              <>
                {isOn ? (
                  <Box color={theme.colors.accent1} display="flex" justifyContent="center" alignItems="center">
                    <Typography variant="overline" component="span">
                      <Box color={theme.colors.accent1}>OPT-IN</Box>
                    </Typography>
                  </Box>
                ) : (
                  <Box color={theme.colors.accent1} display="flex" justifyContent="center" alignItems="center">
                    <Typography variant="overline" component="span">
                      <Box color={theme.colors.accent1}>OPT-OUT</Box>
                    </Typography>
                  </Box>
                )}
              </>
            )
          }}
          onDisabledState={() => {
            return (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="caption" component="span">
                  <Box color={theme.colors.accent}>OPT-IN</Box>
                </Typography>
              </Box>
            )
          }}
          offDisabledState={() => {
            return (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="caption" component="span">
                  <Box color={theme.colors.accent}>OPT-OUT</Box>
                </Typography>
              </Box>
            )
          }}
        />
      )

      case SwitchDesignModes.LOCATION_SWITCH:
      return (
        <FancySwitch
          {...rest}
          small 
          bgcolor={theme.colors.bgPrimary}
          activeBGColor={theme.colors.supplementary1}
          onInactiveTextColor={theme.colors.supplementary1}
          offInactiveTextColor={theme.colors.supplementary1}
        />
      )
  }
}
